<template>
  <div class="justify-center layout px-0">
    <v-btn icon class="mx-0">
      <v-icon color="teal" @click="edit">edit</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    orderItem: null,
  }),
  methods: {
    edit() {
      this.params.clicked(this.params.data);
    },
  },
});
</script>